<template>
  <div class="textarea-input clearfix">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label
      :for="options.name"
      :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <textarea
          :placeholder="options.placeholder"
          :id="options.name"
          class="form-control"
          type="text" :value="value"
          :name="options.name"
          :style="{ minHeight: options.height || '150px' }"
          @input="validate($event.target.value)">
        </textarea>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'TextareaInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false,
          placeholder: ''
        }
      }
    }
  },
  data () {
    return {
      isLength: true,
      isRegex: true,
      isValid: false,
      isDirty: false,
      minLength: 1,
      invalidMessage: this.options.label + ' is required'
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  mounted () {
    this.validate(this.value)
    this.isDirty = false
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isLength = this.isValid = val.length >= this.minLength
        this.isDirty = true
      } else if (this.options.required) {
        this.isValid = false
        this.isDirty = true
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/TextareaInput.vue